import React from 'react';
import { ContactSection } from './components/ContactSection';
import { EventHero } from './components/EventHero';
import { GallerySection } from './components/GallerySection';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink text-ivory selection:bg-sage selection:text-ink" data-id="element-0" data-mp="3k9uin7mutsah">
      <main data-id="element-1" data-mp="3fbt2augtc72p">
        <EventHero data-id="element-2" data-mp="3fb9jlbjc9enm" />
        <GallerySection data-id="element-3" data-mp="3f8ndlgc3j77i" />
      </main>
      <ContactSection data-id="element-4" data-mp="2rk45p1wykwfy" />
    </div>;
}